import { all, call } from 'redux-saga/effects';
import userSagas from './user/user.sagas';
import websitesSagas from './websites/websites.sagas';
import operatorSagas from './operators/operators.sagas';
import blacklistSagas from './blacklist/blacklist.sagas';
import paymentsSagas from './payments/payments.sagas';
import conversationsSagas from './conversations/conversations.sagas';
import departmentsSagas from './departments/departments.sagas';
import customerSuccess from './customerSuccess/cs.sagas';
import webhookSagas from './webhook/webhook.sagas';
import faqSagas from './faq/faq.saga';
import convsArchiveSagas from './convsArchive/convsArchive.sagas';
import settingsSaga from './settings/settings.saga';
import affiliateSaga from './affiliate/affiliate.saga';
import appslistSaga from './appslist/appslist.saga';
import knowledgeBaseSaga from './knowledgeBase/knowledgeBase.saga';
import dashboardSagas from './dashboard/dashboard.sagas';
import userVisitsSaga from './userVisitsArchive/userVisitsArchive.saga';

export default function* rootSaga() {
  yield all([
    call(userSagas),
    call(websitesSagas),
    call(dashboardSagas),
    call(operatorSagas),
    call(blacklistSagas),
    call(paymentsSagas),
    call(conversationsSagas),
    call(departmentsSagas),
    call(customerSuccess),
    call(webhookSagas),
    call(faqSagas),
    call(convsArchiveSagas),
    call(settingsSaga),
    call(affiliateSaga),
    call(appslistSaga),
    call(knowledgeBaseSaga),
    call(userVisitsSaga),
  ]);
}
